import axiosInstance from "./AxiosConfig";

class ClientsGroup {
  async CreateClientGroup(name) {
    
    try {
      const response = await axiosInstance.post("/clientGroup/create", {
        name,
      });
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetClientGroups() {
    try {
      const response = await axiosInstance.get("/clientGroup/getall");
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetClientGroupById(id) {
    try {
      const response = await axiosInstance.get(`/clientGroup/getbyid/${id}`);
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateClientGroupById(id, name) {
    try {
      const response = await axiosInstance.put(`/clientGroup/update/${id}`, {
        name,
      });
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteClientGroupById(id) {
    
    try {
      const response = await axiosInstance.delete(`/clientGroup/delete/${id}`);
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async AddBranchToGroup(data) {
    
    const { groupId, branchId } = data;
    try {
      const response = await axiosInstance.post(
        `/clientGroup/${groupId}/branches/${branchId}`,
        data
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ClientsGroup();
